var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-head fb fb-main-center fb-cross-center",style:(`width: ${_vm.size}px; height: ${_vm.size}px;`)},[(_vm.headImgUrl)?_c('img',{attrs:{"src":_vm.headImgUrl}}):_c('span',{staticClass:"font-24"},[_vm._v(_vm._s(_vm.computedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }